import { lazy, Suspense } from 'react';

const LazyApplicationHeader = lazy(() => import('./application-header.jsx'));

const ApplicationHeader = (props) => (
  <Suspense fallback={null}>
    <div className="container-fluid" id="headline-navigation">
      <LazyApplicationHeader {...props} />
    </div>
  </Suspense>
);

export default ApplicationHeader;
